import { useQuery } from 'react-query'
import adminManagementService from 'Services/adminManagementService'
import { ADMIN_SCOPE, CurrentAdmin } from 'Models/AdminManagement'

// The signed-in admin, from GET /auth/me.
export const useCurrentAdmin = () => {
  const query = useQuery<CurrentAdmin>(
    'currentAdmin',
    () => adminManagementService.getCurrentAdmin(),
    {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  )

  const roles = query.data?.roles ?? []
  const isSuperAdmin = roles.includes(ADMIN_SCOPE.SUPER_ADMIN)
  const isDeveloper = roles.includes(ADMIN_SCOPE.DEVELOPER)

  return {
    ...query,
    admin: query.data,
    roles,
    isSuperAdmin,
    isDeveloper,
    canCreateAdmin: isSuperAdmin || isDeveloper,
    canManageAdmins: isSuperAdmin,
    canManageRoles: isSuperAdmin,
  }
}

export default useCurrentAdmin
